import { render, staticRenderFns } from "./CategorySelectionComposite.vue?vue&type=template&id=4b8e2d27&lang=pug"
import script from "./CategorySelectionComposite.vue?vue&type=script&lang=js"
export * from "./CategorySelectionComposite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports